module.exports = __webpack_public_path__ + "static/media/106.c9d54f94.png";